export default "__VITE_ASSET__$T8pIkBf__"